import React, { Component } from 'react'
import Nav from '../Nav'
import Description from './Description'
import VideoBG from './VideoBG'
import Footer from '../Footer';
import SectionTwo from '../SectionTwo';

export default class Nots extends Component {
  render() {
    return (
      <div>
          <Nav/>

          <VideoBG/>

          <Description/>

          <SectionTwo />

          <Footer/>
      </div>
    )
  }
}
